module.exports = __webpack_public_path__ + "media/marker/map-pin-0c46d4b5.png";